export default {"src":"/_next/static/media/custom-html-tag.b6c8e24f.svg","height":106,"width":260,"blurWidth":0,"blurHeight":0};